<template lang="pug">
include ../../../../prototype/src/pug/abstracts/variables
include ../../../../prototype/src/pug/abstracts/mixin.pug
tbody
	tr.head
		th('v-html'="row.title")
		th e-CPF A1
		th e-CPF A3
		th e-CNPJ A1
		th e-CNPJ A3
		th e-Jurídico
	tr('v-for'="item in row.data")
		td('v-html'="item.name") DACON - Demontrativo de Apuração de Contribuições
		td('v-for'="check in item.values")
			+i('icon_detalhe_check.svg')('v-if'="check")
</template>

<script>
export default {
	name: "ComprarRow",
	props: [ "row" ]
}
</script>